// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class OtiService {
  public redirectFrom: any;
  private filters: any;
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  // Set filter when redirect from Home page
  setFilters(filters: any): void {
    this.filters = filters;
  }
  // Get filter when redirect from Home page
  getFilters(): any {
    return this.filters;
  }
  // Clear filter when redirect from Home page
  clearFilters(): void {
    this.filters = null;
  }

  // Get OTI dashboard filter data
  public getDashboardFilterData() {
    return this.networkService.getRequest(this.configService.getOtiDashboardFilter());
  }

  // Get OTI dashboard filter data
  public getOTIOrderFilterData(selectedTab) {
    return this.networkService.getRequest(this.configService.getOtiOrderFilter() + '?selectedTab=' + selectedTab);
  }

  // Get OTI order data
  public getOTIOrderList(filter) {
    return this.networkService.postRequest(this.configService.getOtiOrderList(), filter);
  }

  // Get OTI order data
  public getOTIOrderLandingList(filter) {
    return this.networkService.postRequest(this.configService.getOtiOrderLandingList(), filter);
  }

  // Get OTI Seed order data
  public getOTISeedOrderLandingList(filter) {
    return this.networkService.postRequest(this.configService.getOtiSeedOrderLandingList(), filter);
  }

  // Get OTI summary data
  public getOTISummary(salesOrderNumber,orderType) {
    return this.networkService.getRequest(this.configService.getOTISummaryData() + '?salesOrderNumber=' + salesOrderNumber + '&orderType=' + orderType);
  }

  // Get OTI user profile
  public getOTIUserProfile() {
    return this.networkService.getRequest(this.configService.getOTIUserProfile());
  }

  // SET oti default product segment
  public setDefaultProductSegment(filter) {
    return this.networkService.postRequest(this.configService.setDefaultProductSegment(), filter);
  }
  // Get OTI history days
  public getOTIHistoryDays() {
    return this.networkService.getRequest(this.configService.getOTIHistoryDays());
  }

  // Get OTI Export data
  public getOTIExportList(filter) {
    return this.networkService.postRequest(this.configService.getOtiExportList(), filter);
  }

  // OIP

  // Get OIP dashboard filter Master data

  public getFilterMasterDataOIP() {
    return this.networkService.getRequest(this.configService.getFilterMasterDataOip());
  }

  // Get OIP dashboard data

  public getDataOip(filter) {
    return this.networkService.postRequest(this.configService.getDataOip(), filter);
  }
  public getSeedSearchList() {
    return this.networkService.getRequest(this.configService.getSeedSearchList());
  }

  // Get survey message eligibility for OTI
  public checkSurveyMessageEligibilty() {
    return this.networkService.getRequest(this.configService.checkOTISurveyMessageEligibiltyData());
  }
  // save user survey preference
  public saveSurveyPreference(response) {
    return this.networkService.postRequest(this.configService.saveSurveyPreferenceData(), response);
  }
}
